 	// install a JSONP callback for chunk loading
 	function webpackJsonpCallback(data) {
 		var chunkIds = data[0];
 		var moreModules = data[1];
 		var executeModules = data[2];

 		// add "moreModules" to the modules object,
 		// then flag all "chunkIds" as loaded and fire callback
 		var moduleId, chunkId, i = 0, resolves = [];
 		for(;i < chunkIds.length; i++) {
 			chunkId = chunkIds[i];
 			if(Object.prototype.hasOwnProperty.call(installedChunks, chunkId) && installedChunks[chunkId]) {
 				resolves.push(installedChunks[chunkId][0]);
 			}
 			installedChunks[chunkId] = 0;
 		}
 		for(moduleId in moreModules) {
 			if(Object.prototype.hasOwnProperty.call(moreModules, moduleId)) {
 				modules[moduleId] = moreModules[moduleId];
 			}
 		}
 		if(parentJsonpFunction) parentJsonpFunction(data);

 		while(resolves.length) {
 			resolves.shift()();
 		}

 		// add entry modules from loaded chunk to deferred list
 		deferredModules.push.apply(deferredModules, executeModules || []);

 		// run deferred modules when all chunks ready
 		return checkDeferredModules();
 	};
 	function checkDeferredModules() {
 		var result;
 		for(var i = 0; i < deferredModules.length; i++) {
 			var deferredModule = deferredModules[i];
 			var fulfilled = true;
 			for(var j = 1; j < deferredModule.length; j++) {
 				var depId = deferredModule[j];
 				if(installedChunks[depId] !== 0) fulfilled = false;
 			}
 			if(fulfilled) {
 				deferredModules.splice(i--, 1);
 				result = __webpack_require__(__webpack_require__.s = deferredModule[0]);
 			}
 		}

 		return result;
 	}

 	// The module cache
 	var installedModules = {};

 	// object to store loaded CSS chunks
 	var installedCssChunks = {
 		18: 0
 	};

 	// object to store loaded and loading chunks
 	// undefined = chunk not loaded, null = chunk preloaded/prefetched
 	// Promise = chunk loading, 0 = chunk loaded
 	var installedChunks = {
 		18: 0
 	};

 	var deferredModules = [];

 	// script path function
 	function jsonpScriptSrc(chunkId) {
 		return __webpack_require__.p + "" + ({"0":"styles","1":"18389ac5eacc5ba68c2053858d81c8647af01c3f","2":"f08a028ccab136bf00436aec139f88f0fa019d86","3":"0ce814af0a3dfb2d1442d0ca9204ba375f1a53e0","4":"97c907ce537b7cbdfa41f556182f2750ff685301","5":"c304476c375035fe5ab57f96826d1ad6ff657af5","6":"framework","7":"33ce6ab0","8":"4c355f13","9":"c05b8182","10":"component---src-pages-layout-js","11":"152025db965c661bb24971169d0795fbb208a411","12":"bf8ae653ceedbcb9aee81fe0aff53ae73c0db6ef","13":"3f985f62e6c52f7e8bc97d6e9a76b184f2711dc4","14":"b9b041f39dc3568dd313b944196020ea562c7d57","15":"bc62dab504a71ef8c5d240a105694d09627f06f3","16":"component---src-pages-integration-builder-sections-code-tsx","17":"d5ceeaead26c68f645dc39122ccc1b9861fd8433","19":"11e8d57d","21":"4b80be75","22":"5cf42e9e","23":"962beaf7","25":"component---src-pages-404-js","26":"component---src-pages-banner-js","27":"component---src-pages-build-better-js","28":"component---src-pages-classic-home-js","29":"component---src-pages-docs-template-js","30":"component---src-pages-home-js","31":"component---src-pages-index-js","32":"component---src-pages-integration-builder-index-tsx","33":"component---src-pages-integration-builder-sections-build-tsx","34":"component---src-pages-integration-builder-sections-card-generator-tsx","35":"component---src-pages-integration-builder-sections-configure-tsx","36":"component---src-pages-integration-builder-sections-demo-tsx","37":"component---src-pages-integration-builder-sections-help-modal-tsx","38":"component---src-pages-integration-builder-sections-know-before-you-code-tsx","39":"component---src-pages-integration-builder-sections-preview-tsx","40":"component---src-pages-integration-builder-sections-take-live-tsx","41":"component---src-pages-internal-js","42":"component---src-pages-signup-js","43":"component---src-pages-signupauto-js","44":"component---src-pages-support-js","45":"component---src-pages-thankyou-js","46":"component---src-pages-unsubscribe-js","47":"component---src-pages-video-collection-tsx","48":"component---src-pages-video-home-tsx","49":"component---src-pages-video-watch-tsx","50":"component---src-templates-template-layout-js","51":"d7eeaac4"}[chunkId]||chunkId) + "-" + {"0":"0ec71dd62c66cb95665c","1":"383eb8f50d8eb6cff946","2":"1c7b69f213d7c3986414","3":"104e309ac120c3808e52","4":"4c69e77e77aacdd151c4","5":"00dde96eba5adb518a16","6":"017fbc2a41599a88b493","7":"daa4b98381c602367b38","8":"ea3ae2df9a1385079dad","9":"86ab36dd9f335dd6e03d","10":"6e08418c605569741cf3","11":"c2bea52882a1a0261679","12":"b23159743164f28d7ab5","13":"cbc135c848989f6d06f1","14":"4ae0d3306bd016ab5219","15":"8a03fd149ed786d0b97a","16":"34a36739908b2623a4bc","17":"716e92e753fac19e0731","19":"354491bd2b89136083d7","21":"522ec62bf5a41b889981","22":"87441d3ed2834d03e6ee","23":"3468fda8fe10f42b6a98","25":"8fcdeefc09d05231254b","26":"1809c4a561e8094e3458","27":"3acdb3f44586f649a3e4","28":"a6753f15f62c0c25c60b","29":"7e669bf095220dbdadbf","30":"7fc3ad9526130c9507bc","31":"134cab94b6d847efe0a1","32":"49f7947d9168d6bc91fe","33":"a338cd3d4e3257843aa6","34":"0f7f61f1ec767809e383","35":"25e558f25aa2b1212db6","36":"d992f026ca5c3ad0771c","37":"64a3bc6010d85113f4bf","38":"2a749e54f6e65f25c8a7","39":"457a7314cd3caa5558f2","40":"98da209e8f32ac47cbf1","41":"8892c597528ace35fc3d","42":"f55abea68461476d190b","43":"cc8dd6b722d64c03ecc3","44":"8d11ae19b940648d681f","45":"7271d2504d186bd90680","46":"49e17a14152def92f8ea","47":"abe446d958ae290f60f3","48":"57ba08e905913db20ad2","49":"704533a096bf985f96c4","50":"0ab7708f467c75a46a4d","51":"189bb601f4fd429c4d3e"}[chunkId] + ".js"
 	}

 	// The require function
 	function __webpack_require__(moduleId) {

 		// Check if module is in cache
 		if(installedModules[moduleId]) {
 			return installedModules[moduleId].exports;
 		}
 		// Create a new module (and put it into the cache)
 		var module = installedModules[moduleId] = {
 			i: moduleId,
 			l: false,
 			exports: {}
 		};

 		// Execute the module function
 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);

 		// Flag the module as loaded
 		module.l = true;

 		// Return the exports of the module
 		return module.exports;
 	}

 	// This file contains only the entry chunk.
 	// The chunk loading function for additional chunks
 	__webpack_require__.e = function requireEnsure(chunkId) {
 		var promises = [];


 		// mini-css-extract-plugin CSS loading
 		var cssChunks = {"0":1};
 		if(installedCssChunks[chunkId]) promises.push(installedCssChunks[chunkId]);
 		else if(installedCssChunks[chunkId] !== 0 && cssChunks[chunkId]) {
 			promises.push(installedCssChunks[chunkId] = new Promise(function(resolve, reject) {
 				var href = "" + ({"0":"styles","1":"18389ac5eacc5ba68c2053858d81c8647af01c3f","2":"f08a028ccab136bf00436aec139f88f0fa019d86","3":"0ce814af0a3dfb2d1442d0ca9204ba375f1a53e0","4":"97c907ce537b7cbdfa41f556182f2750ff685301","5":"c304476c375035fe5ab57f96826d1ad6ff657af5","6":"framework","7":"33ce6ab0","8":"4c355f13","9":"c05b8182","10":"component---src-pages-layout-js","11":"152025db965c661bb24971169d0795fbb208a411","12":"bf8ae653ceedbcb9aee81fe0aff53ae73c0db6ef","13":"3f985f62e6c52f7e8bc97d6e9a76b184f2711dc4","14":"b9b041f39dc3568dd313b944196020ea562c7d57","15":"bc62dab504a71ef8c5d240a105694d09627f06f3","16":"component---src-pages-integration-builder-sections-code-tsx","17":"d5ceeaead26c68f645dc39122ccc1b9861fd8433","19":"11e8d57d","21":"4b80be75","22":"5cf42e9e","23":"962beaf7","25":"component---src-pages-404-js","26":"component---src-pages-banner-js","27":"component---src-pages-build-better-js","28":"component---src-pages-classic-home-js","29":"component---src-pages-docs-template-js","30":"component---src-pages-home-js","31":"component---src-pages-index-js","32":"component---src-pages-integration-builder-index-tsx","33":"component---src-pages-integration-builder-sections-build-tsx","34":"component---src-pages-integration-builder-sections-card-generator-tsx","35":"component---src-pages-integration-builder-sections-configure-tsx","36":"component---src-pages-integration-builder-sections-demo-tsx","37":"component---src-pages-integration-builder-sections-help-modal-tsx","38":"component---src-pages-integration-builder-sections-know-before-you-code-tsx","39":"component---src-pages-integration-builder-sections-preview-tsx","40":"component---src-pages-integration-builder-sections-take-live-tsx","41":"component---src-pages-internal-js","42":"component---src-pages-signup-js","43":"component---src-pages-signupauto-js","44":"component---src-pages-support-js","45":"component---src-pages-thankyou-js","46":"component---src-pages-unsubscribe-js","47":"component---src-pages-video-collection-tsx","48":"component---src-pages-video-home-tsx","49":"component---src-pages-video-watch-tsx","50":"component---src-templates-template-layout-js","51":"d7eeaac4"}[chunkId]||chunkId) + "." + {"0":"0e0168b70c5b509309fd","1":"31d6cfe0d16ae931b73c","2":"31d6cfe0d16ae931b73c","3":"31d6cfe0d16ae931b73c","4":"31d6cfe0d16ae931b73c","5":"31d6cfe0d16ae931b73c","6":"31d6cfe0d16ae931b73c","7":"31d6cfe0d16ae931b73c","8":"31d6cfe0d16ae931b73c","9":"31d6cfe0d16ae931b73c","10":"31d6cfe0d16ae931b73c","11":"31d6cfe0d16ae931b73c","12":"31d6cfe0d16ae931b73c","13":"31d6cfe0d16ae931b73c","14":"31d6cfe0d16ae931b73c","15":"31d6cfe0d16ae931b73c","16":"31d6cfe0d16ae931b73c","17":"31d6cfe0d16ae931b73c","19":"31d6cfe0d16ae931b73c","21":"31d6cfe0d16ae931b73c","22":"31d6cfe0d16ae931b73c","23":"31d6cfe0d16ae931b73c","25":"31d6cfe0d16ae931b73c","26":"31d6cfe0d16ae931b73c","27":"31d6cfe0d16ae931b73c","28":"31d6cfe0d16ae931b73c","29":"31d6cfe0d16ae931b73c","30":"31d6cfe0d16ae931b73c","31":"31d6cfe0d16ae931b73c","32":"31d6cfe0d16ae931b73c","33":"31d6cfe0d16ae931b73c","34":"31d6cfe0d16ae931b73c","35":"31d6cfe0d16ae931b73c","36":"31d6cfe0d16ae931b73c","37":"31d6cfe0d16ae931b73c","38":"31d6cfe0d16ae931b73c","39":"31d6cfe0d16ae931b73c","40":"31d6cfe0d16ae931b73c","41":"31d6cfe0d16ae931b73c","42":"31d6cfe0d16ae931b73c","43":"31d6cfe0d16ae931b73c","44":"31d6cfe0d16ae931b73c","45":"31d6cfe0d16ae931b73c","46":"31d6cfe0d16ae931b73c","47":"31d6cfe0d16ae931b73c","48":"31d6cfe0d16ae931b73c","49":"31d6cfe0d16ae931b73c","50":"31d6cfe0d16ae931b73c","51":"31d6cfe0d16ae931b73c"}[chunkId] + ".css";
 				var fullhref = __webpack_require__.p + href;
 				var existingLinkTags = document.getElementsByTagName("link");
 				for(var i = 0; i < existingLinkTags.length; i++) {
 					var tag = existingLinkTags[i];
 					var dataHref = tag.getAttribute("data-href") || tag.getAttribute("href");
 					if(tag.rel === "stylesheet" && (dataHref === href || dataHref === fullhref)) return resolve();
 				}
 				var existingStyleTags = document.getElementsByTagName("style");
 				for(var i = 0; i < existingStyleTags.length; i++) {
 					var tag = existingStyleTags[i];
 					var dataHref = tag.getAttribute("data-href");
 					if(dataHref === href || dataHref === fullhref) return resolve();
 				}
 				var linkTag = document.createElement("link");
 				linkTag.rel = "stylesheet";
 				linkTag.type = "text/css";
 				linkTag.onload = resolve;
 				linkTag.onerror = function(event) {
 					var request = event && event.target && event.target.src || fullhref;
 					var err = new Error("Loading CSS chunk " + chunkId + " failed.\n(" + request + ")");
 					err.code = "CSS_CHUNK_LOAD_FAILED";
 					err.request = request;
 					delete installedCssChunks[chunkId]
 					linkTag.parentNode.removeChild(linkTag)
 					reject(err);
 				};
 				linkTag.href = fullhref;

 				var head = document.getElementsByTagName("head")[0];
 				head.appendChild(linkTag);
 			}).then(function() {
 				installedCssChunks[chunkId] = 0;
 			}));
 		}

 		// JSONP chunk loading for javascript

 		var installedChunkData = installedChunks[chunkId];
 		if(installedChunkData !== 0) { // 0 means "already installed".

 			// a Promise means "currently loading".
 			if(installedChunkData) {
 				promises.push(installedChunkData[2]);
 			} else {
 				// setup Promise in chunk cache
 				var promise = new Promise(function(resolve, reject) {
 					installedChunkData = installedChunks[chunkId] = [resolve, reject];
 				});
 				promises.push(installedChunkData[2] = promise);

 				// start chunk loading
 				var script = document.createElement('script');
 				var onScriptComplete;

 				script.charset = 'utf-8';
 				script.timeout = 120;
 				if (__webpack_require__.nc) {
 					script.setAttribute("nonce", __webpack_require__.nc);
 				}
 				script.src = jsonpScriptSrc(chunkId);

 				// create error before stack unwound to get useful stacktrace later
 				var error = new Error();
 				onScriptComplete = function (event) {
 					// avoid mem leaks in IE.
 					script.onerror = script.onload = null;
 					clearTimeout(timeout);
 					var chunk = installedChunks[chunkId];
 					if(chunk !== 0) {
 						if(chunk) {
 							var errorType = event && (event.type === 'load' ? 'missing' : event.type);
 							var realSrc = event && event.target && event.target.src;
 							error.message = 'Loading chunk ' + chunkId + ' failed.\n(' + errorType + ': ' + realSrc + ')';
 							error.name = 'ChunkLoadError';
 							error.type = errorType;
 							error.request = realSrc;
 							chunk[1](error);
 						}
 						installedChunks[chunkId] = undefined;
 					}
 				};
 				var timeout = setTimeout(function(){
 					onScriptComplete({ type: 'timeout', target: script });
 				}, 120000);
 				script.onerror = script.onload = onScriptComplete;
 				document.head.appendChild(script);
 			}
 		}
 		return Promise.all(promises);
 	};

 	// expose the modules object (__webpack_modules__)
 	__webpack_require__.m = modules;

 	// expose the module cache
 	__webpack_require__.c = installedModules;

 	// define getter function for harmony exports
 	__webpack_require__.d = function(exports, name, getter) {
 		if(!__webpack_require__.o(exports, name)) {
 			Object.defineProperty(exports, name, { enumerable: true, get: getter });
 		}
 	};

 	// define __esModule on exports
 	__webpack_require__.r = function(exports) {
 		if(typeof Symbol !== 'undefined' && Symbol.toStringTag) {
 			Object.defineProperty(exports, Symbol.toStringTag, { value: 'Module' });
 		}
 		Object.defineProperty(exports, '__esModule', { value: true });
 	};

 	// create a fake namespace object
 	// mode & 1: value is a module id, require it
 	// mode & 2: merge all properties of value into the ns
 	// mode & 4: return value when already ns object
 	// mode & 8|1: behave like require
 	__webpack_require__.t = function(value, mode) {
 		if(mode & 1) value = __webpack_require__(value);
 		if(mode & 8) return value;
 		if((mode & 4) && typeof value === 'object' && value && value.__esModule) return value;
 		var ns = Object.create(null);
 		__webpack_require__.r(ns);
 		Object.defineProperty(ns, 'default', { enumerable: true, value: value });
 		if(mode & 2 && typeof value != 'string') for(var key in value) __webpack_require__.d(ns, key, function(key) { return value[key]; }.bind(null, key));
 		return ns;
 	};

 	// getDefaultExport function for compatibility with non-harmony modules
 	__webpack_require__.n = function(module) {
 		var getter = module && module.__esModule ?
 			function getDefault() { return module['default']; } :
 			function getModuleExports() { return module; };
 		__webpack_require__.d(getter, 'a', getter);
 		return getter;
 	};

 	// Object.prototype.hasOwnProperty.call
 	__webpack_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };

 	// __webpack_public_path__
 	__webpack_require__.p = "https://www.paypalobjects.com/ppdevdocs/ecmhomepagebundle/";

 	// on error function for async loading
 	__webpack_require__.oe = function(err) { console.error(err); throw err; };

 	var jsonpArray = window["webpackJsonp"] = window["webpackJsonp"] || [];
 	var oldJsonpFunction = jsonpArray.push.bind(jsonpArray);
 	jsonpArray.push = webpackJsonpCallback;
 	jsonpArray = jsonpArray.slice();
 	for(var i = 0; i < jsonpArray.length; i++) webpackJsonpCallback(jsonpArray[i]);
 	var parentJsonpFunction = oldJsonpFunction;


 	// run deferred modules from other chunks
 	checkDeferredModules();
